module.exports = __webpack_public_path__ + "assets/img/nx-03.c04f8f04.jpg";